<!--
Author:
Create Time: 2020-04-13 09:22:08
Description: 收费标准选择框
-->
<template>
  <div class="com-populregister-select">
      <span>
          <el-input
            placeholder
            v-model="label"
            @focus="handleInputClick"
            :disabled="disabled"
            data-ignore-clearable="true"
            data-ignore-at-clear="handleClear"
            :title="label"
          ></el-input>
      </span>

      <proCostnormRefList
        ref="proCostnormRefList"
        :visible="isproCostnormRefVisible"
        @confirm="handleproCostnormRefConfirm"
        :multiple="multiple"
        @cancel="handleproCostnormRefCancel"
        :costnormIds="costnormIds"
        append-to-body
        width="65%"
      />
  </div>
</template>

<script>
export default {
  name: 'proCostnormSelect',
  props: {
      value: {
          type: [String, Array, undefined],
          default: () => ''
      },
      label: {
          type: String,
          default: () => ''
      },
      disabled: {
          type: Boolean,
          default: () => false
      },
      costnormIds:{
        type: Array,
        default: () => []
      }
  },
  data () {
    return {
        isproCostnormRefVisible: false,
    }
  },
  computed: {
      multiple() {
          return Array.isArray(this.value);
      },
  },
  methods: {
      handleInputClick() {
          this.isproCostnormRefVisible = true;
      },
      handleClear() {},
      handleproCostnormRefConfirm(value) {
          let val = Array.isArray(value) ? value.map(o => o.id) : value.id;
          this.$emit('update:value', val, value);
          this.$emit('change', val, value);
          this.$emit('input', val, value);
          this.$emit('changeCostnorm',val,value.name,value.calcType,value.price,value.accuracy,value.costsubjId);
          this.isproCostnormRefVisible = false;
      },
      handleproCostnormRefCancel() {
          this.isproCostnormRefVisible = false;
      },
  }
}
</script>

<style scoped lang="less">
.com-populregister-select {
    display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/proCostnormRegister/proCostnormSelectList.vue